/**
 * 离线API
 *
 * @Author:szs
 * @Date: 2021-08-17
 * @Last Modified time: 2021-08-17
 */

import http from '@/utils/request'
const apis = {
  // 获取离线模板列表
  getModelOfflineSettingsList(dto) {
    return http.get({
      url: 'pc/modelOfflineSettings/getModelOfflineSettingsList',
      data: dto
    })
  },
  // 获取全部离线模板
  getDataHisOfflineList(dto) {
    return http.get({
      url: '/pc/objDeviceAttributeOffline/getDataHisOfflineList',
      data: dto
    })
  },
  // 获取全部离线模板
  getModelOfflineSettingss(dto) {
    return http.get({
      url: 'pc/modelOfflineSettings/getModelOfflineSettingss',
      data: dto
    })
  },

  // 获取离线模板
  getModelOfflineSettings(dto) {
    return http.get({
      url: 'pc/modelOfflineSettings/getModelOfflineSettings',
      data: dto
    })
  },

  // 保存离线模板
  saveModelOfflineSettings(dto) {
    return http.post({
      url: 'pc/modelOfflineSettings/saveModelOfflineSettings',
      data: dto,
      typea: 1
    })
  },

  // 删除离线模板
  delModelOfflineSettings(id) {
    return http.post({
      url: 'pc/modelOfflineSettings/delModelOfflineSettings',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取设备属性离线列表
  getDeviceAttributeOfflineList(dto) {
    return http.get({
      url: 'pc/objDeviceAttributeOffline/getDeviceAttributeOfflineList',
      data: dto
    })
  },

  // 获取设备属性离线
  getDeviceAttributeOffline(dto) {
    return http.get({
      url: 'pc/objDeviceAttributeOffline/getDeviceAttributeOffline',
      data: dto
    })
  },

  // 保存设备属性离线
  saveDeviceAttributeOffline(dto) {
    return http.post({
      url: 'pc/objDeviceAttributeOffline/saveDeviceAttributeOffline',
      data: dto
    })
  },

  // 删除设备属性离线
  delDeviceAttributeOffline(id) {
    return http.post({
      url: 'pc/objDeviceAttributeOffline/delDeviceAttributeOffline',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取用户离线设置
  getUserOfflineSet(dto) {
    return http.get({
      url: 'pc/objDeviceAttributeOffline/getUserOfflineSet',
      data: dto
    })
  },

  // 保存用户离线设置
  saveUserOfflineSet(dto) {
    return http.post({
      url: 'pc/objDeviceAttributeOffline/saveUserOfflineSet',
      data: dto
    })
  },

  // 获取设备分组离线列表
  getDeviceGroupOfflineList(dto) {
    return http.get({
      url: 'pc/objDeviceGroupOffline/getDeviceGroupOfflineList',
      data: dto
    })
  },

  // 获取设备分组离线
  getDeviceGroupOffline(dto) {
    return http.get({
      url: 'pc/objDeviceGroupOffline/getDeviceGroupOffline',
      data: dto
    })
  },

  // 保存设备分组离线
  saveDeviceGroupOffline(dto) {
    return http.post({
      url: 'pc/objDeviceGroupOffline/saveDeviceGroupOffline',
      data: dto
    })
  },

  // 删除设备分组离线
  delDeviceGroupOffline(id) {
    return http.post({
      url: 'pc/objDeviceGroupOffline/delDeviceGroupOffline',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  }
}
export default apis
